import React from "react"
import type { FieldValues, Path, UseFormRegister } from "react-hook-form"

interface ControlledInputProps<TFieldValues extends FieldValues> {
  register: UseFormRegister<TFieldValues>
  name: Path<TFieldValues>
}

export function ControlledInput<TFieldValues extends FieldValues>({
  register,
  name,
}: ControlledInputProps<TFieldValues>) {
  return (
    <input
      {...register(name)}
      type="text"
      className="block h-12 w-full rounded-md border border-gray-300 px-3 shadow-sm focus:border-primary"
    />
  )
}
